<wsb-atlas-grid
#grid
class="atlas-grid-simplest"
class="mt-2"
[columnDefs]="tableColumnDefs"
[options]="tableGridOptions"
[@gridIsLoaded]="gridAnimationState"
[components]="components">
</wsb-atlas-grid>
